<template>
  <div class="ui big error message">      
    <p>{{message}}</p>
    <div class="ui accordion" ref="debugInfo" v-if="exception">
      <div class="ui title">
        <i class="dropdown icon"></i>
        {{$t('More info')}}
      </div>
      <div class="content">
        <pre class="transition hidden">{{exception.stack || exception}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'exception'],
  mounted() {
    window.$(this.$refs.debugInfo).accordion();
  },
}
</script>

<style scoped>
.ui.accordion pre {
  overflow: auto;
}
</style>
